import { Component } from '@angular/core';

@Component({
  selector: 'pc-facebook-logo',
  standalone: true,
  imports: [],
  templateUrl: './facebook-logo.component.html',
  styleUrl: './facebook-logo.component.scss'
})
export class FacebookLogoComponent {

}
